import request from '@/api/request'

export default {
  async getColors () {
    return (await request.get(`module/action/marketplace/sicoob/color`)).data
  },
  async getSizes () {
    return (await request.get(`module/action/marketplace/sicoob/size`)).data
  },
  async getCategories () {
    return (await request.get(`module/action/marketplace/sicoob/category/retrieve`)).data
  },
  async getBrands () {
    return (await request.get(`module/action/marketplace/sicoob/brand/retrieve`)).data
  }
}



// WEBPACK FOOTER //
// ./src/api/marketplace/sicoob/index.js